"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    ShoppingCartItemClient: Symbol("ShoppingCartItemClient"),
    ShoppingCartPaymentClient: Symbol("ShoppingCartPaymentClient"),
    ShoppingCartItemBatchClient: Symbol("ShoppingCartItemBatchClient"),
    ShoppingCartItemRoute: Symbol("ShoppingCartItemRoute"),
    ShoppingCartPaymentRoute: Symbol("ShoppingCartPaymentRoute"),
    ShoppingCartItemBatchRoute: Symbol("ShoppingCartItemBatchRoute"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ShoppingCartItemClient).to(_1.ShoppingCartItemClient);
    bind(TYPES.ShoppingCartPaymentClient).to(_1.ShoppingCartPaymentClient);
    bind(TYPES.ShoppingCartItemBatchClient).to(_1.ShoppingCartItemBatchClient);
    bind(TYPES.ShoppingCartItemRoute).to(_1.ShoppingCartItemRoute);
    bind(TYPES.ShoppingCartPaymentRoute).to(_1.ShoppingCartPaymentRoute);
    bind(TYPES.ShoppingCartItemBatchRoute).to(_1.ShoppingCartItemBatchRoute);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
